import { Chip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { resolveChipDisplay } from "../lib/macro-chip-utils"

export function MacroChip({ tokenId, size = "small", onClick }) {
    const { macroMap } = useBoundContext()
    const macro = macroMap?.[tokenId]
    const display = resolveChipDisplay(tokenId, macro)

    return (
        <Chip
            size={size}
            label={display.label}
            title={display.tooltip || display.label}
            onClick={onClick}
            icon={display.icon ? <Iconify icon={display.icon} width={16} /> : undefined}
            sx={{
                bgcolor: display.background,
                borderColor: display.borderColor,
                color: display.color,
                border: "1px solid",
                fontWeight: 500,
                cursor: onClick ? "pointer" : "default",
            }}
        />
    )
}
